/*
 * collection-claude-code.js
 *
 * Runtime enhancements for collections rendered on the
 * `claude-code` template.
 *
 * 1. Inject a fixed footer bar into the filter drawer (#halo-
 *    sidebar) with two buttons:
 *      CLEAR   -> triggers the theme's built-in "clear all"
 *                 facet remove link (a.facets__reset /
 *                 a.facets__clear-all). Falls back to
 *                 navigating to the bare collection URL.
 *      APPLY   -> closes the drawer (same as clicking the X or
 *                 the outside-click backdrop). Filter changes
 *                 already apply live in the theme, so there is
 *                 no separate "apply" server call needed.
 *
 * Runs only on the claude-code template (guarded by the body
 * class).
 */
(function () {
  'use strict';

  if (!document.body.classList.contains('template-suffix-claude-code')) {
    return;
  }

  function findSidebar() {
    return document.getElementById('halo-sidebar');
  }

  function findClearLink(sidebar) {
    return (
      sidebar.querySelector('a.facets__clear-all') ||
      sidebar.querySelector('a.facets__reset') ||
      null
    );
  }

  function injectFooter() {
    var sidebar = findSidebar();
    if (!sidebar) return;
    if (sidebar.querySelector('.drawer-footer')) return;

    var footer = document.createElement('div');
    footer.className = 'drawer-footer';

    var clearBtn = document.createElement('button');
    clearBtn.type = 'button';
    clearBtn.className = 'drawer-clear';
    clearBtn.textContent = 'Clear';
    clearBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var link = findClearLink(sidebar);
      if (link && link.href) {
        window.location.href = link.href;
      } else {
        // Fallback: strip all query params from the collection URL.
        var path = window.location.pathname;
        window.location.href = path;
      }
    });

    var applyBtn = document.createElement('button');
    applyBtn.type = 'button';
    applyBtn.className = 'drawer-apply';
    applyBtn.textContent = 'Apply';
    applyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      document.body.classList.remove('open-mobile-sidebar');
    });

    footer.appendChild(clearBtn);
    footer.appendChild(applyBtn);
    sidebar.appendChild(footer);
  }

  // ------------------------------------------------------------
  // View-by: inject a 6th button and take over clicks for 4/5/6.
  //
  // Theme's toolbar.js binds click handlers in its custom
  // element's constructor. If that constructor errors (e.g.
  // because mediaViewMobile is null) or my icon-mode restyling
  // interferes with its bindings, cols 4/5 stop responding.
  // Sidestep: add a single delegated click handler on the whole
  // .toolbar-viewAs container that switches the .productListing
  // class list to column-N based on data-col. Works for 4, 5,
  // and 6 uniformly, no dependency on the theme's own handler.
  // ------------------------------------------------------------
  function setActiveColumn(mv, col) {
    var list = document.querySelector('.productListing');
    if (!list) return;
    list.classList.remove(
      'productList',
      'column-2', 'column-3', 'column-4', 'column-5', 'column-6'
    );
    list.classList.add('productGrid', 'column-' + col);
    mv.querySelectorAll('.icon-mode').forEach(function (b) {
      if (parseInt(b.dataset.col, 10) === col) {
        b.classList.add('active');
      } else {
        b.classList.remove('active');
      }
    });
  }

  // Inject a 6th native .icon-mode so the theme's own logic
  // has something to target, then hide all natives (via CSS)
  // and replace them with a single "VIEW BY {N}" toggle that
  // cycles between 4 and 6.
  function injectSixthViewButton() {
    document.querySelectorAll('[data-view-as]').forEach(function (mv) {
      if (!mv.querySelector('.icon-mode-grid.grid-6')) {
        var six = document.createElement('span');
        six.className = 'toolbar-icon icon-mode icon-mode-grid grid-6';
        six.setAttribute('data-col', '6');
        six.setAttribute('role', 'button');
        six.setAttribute('aria-label', 'Grid 6');
        six.setAttribute('tabindex', '0');
        mv.appendChild(six);
      }

      // Inject / refresh the single-toggle label.
      var toggle = mv.querySelector('.k-view-toggle');
      if (!toggle) {
        toggle = document.createElement('span');
        toggle.className = 'k-view-toggle';
        toggle.setAttribute('role', 'button');
        toggle.setAttribute('tabindex', '0');
        mv.appendChild(toggle);
      }

      function currentCol() {
        var list = document.querySelector('.productListing');
        if (!list) return 4;
        if (list.classList.contains('column-6')) return 6;
        if (list.classList.contains('column-4')) return 4;
        // Anything else (5, 3, 2, list) collapses to 4 by default
        // for this toggle's purposes.
        return 4;
      }

      function paint() {
        toggle.textContent = 'View by ' + currentCol();
      }

      if (toggle.dataset.kBound !== '1') {
        toggle.dataset.kBound = '1';
        toggle.addEventListener('click', function () {
          var next = currentCol() === 4 ? 6 : 4;
          setActiveColumn(mv, next);
          paint();
        });
        toggle.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle.click();
          }
        });
      }

      paint();
    });
  }

  function init() {
    injectFooter();
    injectSixthViewButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-inject after Shopify's Section Rendering API re-mounts the
  // sidebar or the toolbar (happens when filter facets are edited).
  document.addEventListener('shopify:section:load', init);

  // Note: the drawer open/close ownership takeover previously
  // lived here has moved to `drawer-guard.js`, which is loaded
  // site-wide (not just on the claude-code template) so it
  // protects every collection page against the theme's spurious
  // [data-sidebar] delegate firings.
})();
